import React from 'react';

// --- SVG Icons for GPS Status ---
const GpsPresentIcon = () => (
  <svg className="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
  </svg>
);

const GpsMissingIcon = () => (
  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
  </svg>
);


export default function NewRecordsTable({
  records,
  displayedCount,
  onShowMore,
  selectedRecords,
  onRecordSelect,
  onSelectAll,
}) {
  const displayedRecords = records.slice(0, displayedCount);
  const isAllSelected = records.length > 0 && selectedRecords.length === records.length;

  return (
    <div className="flex flex-col">
      <div className="overflow-x-auto rounded-lg border">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={onSelectAll}
                  className="rounded border-gray-400 text-yellow-600 focus:ring-yellow-600 cursor-pointer"
                />
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Date / Time
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Compaction (%)
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Density
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Surf Temp
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Description
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Location
              </th>
               <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Station
              </th>
              <th className="px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Operator
              </th>
              <th className="px-3 py-2 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                GPS
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {displayedRecords.map((record, index) => {
              const hasGPS = record.GPS && record.GPS.trim();
              const isSelected = selectedRecords.includes(record);
              return(
                <tr 
                  key={index} 
                  className={`transition-colors duration-150 ${isSelected ? 'bg-amber-50 hover:bg-amber-100' : 'hover:bg-gray-50'}`}
                >
                  <td className="px-3 py-2 whitespace-nowrap">
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => onRecordSelect(record)}
                      className="rounded border-gray-400 text-yellow-600 focus:ring-yellow-600 cursor-pointer"
                    />
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.DateTime || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.Compaction || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.Density || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.SurfTemp || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs font-medium text-gray-800">
                    {record.Description1 || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.Location1 || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.Station || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500">
                    {record.Operator || 'N/A'}
                  </td>
                  <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-500 flex justify-center">
                    {hasGPS ? <GpsPresentIcon /> : <GpsMissingIcon />}
                  </td>
                </tr>
              )}
            )}
          </tbody>
        </table>
      </div>

      {records.length > displayedCount && (
        <div className="flex justify-center mt-4">
          <button
            onClick={onShowMore}
            className="inline-flex items-center px-4 py-2 bg-gray-100 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-200"
          >
            Show More ({records.length - displayedCount} remaining)
          </button>
        </div>
      )}
    </div>
  );
}
